import React, { useEffect, useState, useRef, useMemo } from 'react';
import FullYarnCountService from '../../services/full-yarn-count.service';
import './full-yarn-count-list.scss';
import {
  GridComponent,
  Inject,
  Toolbar,
  ToolbarItems,
  Edit,
  EditSettingsModel,
  Page,
  Sort,
  PdfExport,
  PdfExportProperties,
  ExcelExport,
  Grid,
  Resize,
  FilterSettingsModel,
  Filter,
  Group,
  GroupSettingsModel,
  AggregateColumnDirective,
  ColumnDirective,
  ColumnsDirective,
  AggregateColumnsDirective,
  AggregateDirective,
  AggregatesDirective,
  Aggregate,
  Freeze,
  ColumnChooser,
  Reorder,
  DialogEditEventArgs,
  CommandColumn,
  CommandModel,
} from '@syncfusion/ej2-react-grids';
import { ClickEventArgs } from '@syncfusion/ej2-react-navigations';
import FullYarnCountAdd from './full-yarn-count-add';
import FullYarnCountEdit from './full-yarn-count-edit';
// import YarnPurchaseContractEdit from './yarn-purchase-contract-edit';
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import fullYarnCountService from '../../services/full-yarn-count.service';
import SecurityService from '../security/security.service';
// import YarnContractDeliveryScheduleList from '../yarn-contract-delivery-schedule/yarn-contract-delivery-schedule-list';
import moment from 'moment';
import securityService from '../security/security.service';
import AuditTableInput from '../audit-table/audit-table';
import HardDelete from '../hard-delete/hard-delete';
let selectedRows = []

export default function FullYarnCountList(props) {
  const [fullYarnCounts, setFullYarnCounts] = useState([]);

  const [deleteDialogVisibility, setDeleteDialogVisibility] = useState(false);
  const [dialogWarningVisibility, setDialogWarningVisibility] = useState(false);
  const [warningMessage, setWarningMessage] = useState("");
  const deleteDialog = useRef();
  const warningDialog = useRef();
  const [showDialogs, setShowDialogs] = useState();
  const [deletingProps, setDeletingProps] = useState();
  const [deletingID, setDeletingID] = useState(0);

  let fullYarnCountGrid: Grid;

  const toolbarClick = (args: ClickEventArgs) => {
    console.log('args.item.properties :', args.item.properties);
    if (
      fullYarnCountGrid &&
      args.item.properties.id === 'fullYarnCountGrid_PDFExport'
    ) {
      const exportProperties: PdfExportProperties = {
        pageOrientation: 'Landscape',
        fileName: `${moment().format('YYYYMMDD')}_full_yarn_count.pdf`
      };
      console.log('clicked on pdf export');
      fullYarnCountGrid.pdfExport(exportProperties);
    }
    if (
      fullYarnCountGrid &&
      args.item.properties.id === 'fullYarnCountGrid_excelexport'
    ) {
      const exportProperties: PdfExportProperties = {
        pageOrientation: 'Landscape',
        fileName: `${moment().format('YYYYMMDD')}_full_yarn_count.xlsx`
      };
      fullYarnCountGrid.excelExport(exportProperties);
    }
    if (
      fullYarnCountGrid &&
      args.item.properties.id === 'fullYarnCountGrid_columnchooser'
    ) {
    }
    
    if (fullYarnCountGrid && args.item.properties.id === 'Delete') {
      console.log('toolbar Delete');
      if (fullYarnCountGrid.selectedRowIndex === -1) {
        // no rows selected
        console.log('Delete ', fullYarnCountGrid.getSelectedRecords()[0]);
        // setDialogWarningVisibility(false);
        let obj={
          TableName:`FullYarnCount`,
          ColumnName:`FullYarnCountID`,
          RowID:undefined,
          SelectedRow:false
          
        }
        setDeletingProps(obj)
        // setShowDialogs(true)
        setWarningMessage("Please select a row first!");
        warningDialog.current.show();

      } else {
        console.log('delete: ', fullYarnCountGrid.getSelectedRecords())
        console.log(selectedRows)
        // deleteDialog.current.hide();
        let obj={
          TableName:`FullYarnCount`,
          ColumnName:`FullYarnCountID`,
          RowID:fullYarnCountGrid.getSelectedRecords()[0]['FullYarnCountID'],
          SelectedRow:true,
          UserID:userId,
          SelectedRowData:{
            FullYarnCount: 
             `${fullYarnCountGrid.getSelectedRecords()[0].YarnCount}/${fullYarnCountGrid.getSelectedRecords()[0].YarnThread}${fullYarnCountGrid.getSelectedRecords()[0].YarnQuality} ${fullYarnCountGrid.getSelectedRecords()[0].YarnType}`
            
      }

          
    }
          setDeletingProps(obj)
        
        // deleteDialog.current.show();
        setShowDialogs(true)
      }
    } 


    // if (
    //   fullYarnCountGrid &&
    //   args.item.properties.id === 'fullYarnCountGrid_Delivery Schedule'
    // ) {
    //   console.log('clicked delivery');
    // }
  };

  useEffect(() => {
    getFullYarnCounts();
  }, []);

  const getFullYarnCounts = async () => {
    FullYarnCountService.getAll()
      .then((response) => {
        console.log('full yarn count get response', response.data.recordset);
        setFullYarnCounts(response.data.recordset);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  // const addYarnContract = () => {
  //   props.history.push('/YarnContract/Purchase/Add');
  // };

  const getRoute = () =>
    window.location.pathname
      .substr(1, window.location.pathname.length)
      .split('/');

  const toolbarOptions: ToolbarItems[] = [
    'Add',
    'Edit',
    {
      text: "Delete",
      tooltipText: "Delete",
      id: "Delete",
      disabled: !SecurityService.canUserAccess('FullYarnCountDelete'),
    },
    'Update',
    'Cancel',
    'PDFExport',
    'ExcelExport',
    'Search',
    'ColumnChooser',
  ];

  // const databound = () =>
  // {
  //     if (fullYarnCountGrid) {
  //       fullYarnCountGrid.autoFitColumns();
  //     }
  // }

  const dialogTemplate = (props) => {
    console.log('props: ', props);
    return props.isAdd ? (
      <FullYarnCountAdd {...props} dataList={fullYarnCounts} > </FullYarnCountAdd>
    ) :
      (
        <FullYarnCountEdit {...props} dataList={fullYarnCounts}> </FullYarnCountEdit>
      );

    // (
    //   <YarnPurchaseContractEdit {...props}></YarnPurchaseContractEdit>
    // );
  };

  const editSettings: EditSettingsModel = {
    allowEditing: SecurityService.canUserAccess('FullYarnCountEdit'),
     allowAdding: SecurityService.canUserAccess('FullYarnCountAdd'),
    allowDeleting: SecurityService.canUserAccess('FullYarnCountDelete'),

    // allowEditing: true,
    // allowAdding: true,
    // allowDeleting: true,

    mode: 'Dialog',
    // showDeleteConfirmDialog: true,
    template: dialogTemplate,
    headerTemplate: '<p></p>',
  };

  const filterOptions: FilterSettingsModel = {
    type: 'Excel',
    // columns: [
    //   {
    //     field: 'IsDeleted',
    //     operator: 'notequal',
    //     value: 'True'
    //   }
    // ]
  };

  const groupOptions: GroupSettingsModel = {
    showDroopArea: true,
  };

  const sortingOptions: SortSettingsModel = {
    columns: [{ field: 'FullYarnCountID', direction: 'Descending' }]
  }

  const footerSum = (e: any) => {
    return <span> Sum: {e.Sum}</span>;
  };

  // const header = () => {
  //   return <div>Yarn Contract Delivery Schedule</div>;
  // };

  //   const contentTemplate = () => {
  //   return (
  //     <div>
  //       <YarnContractDeliveryScheduleList
  //         {...selectedRow}
  //       ></YarnContractDeliveryScheduleList>
  //     </div>
  //   );
  // };

  const actionComplete = (args: DialogEditEventArgs) => {
    console.log('data: ', args);
    if (args?.requestType === 'columnstate') {
      console.log('adjusting column');
      fullYarnCountGrid?.autoFitColumns();
    }
    if (args.form) {
      console.log('data: ', args);
      if (args.requestType === 'beginEdit' || args.requestType === 'add') {
        console.log('e: ', args.form.ej2_instances[0]);
        /** Add Validation Rules */
        args.form.ej2_instances[0].addRules('YarnCountID', { required: true });
        args.form.ej2_instances[0].addRules('YarnThread', { required: true, });
        args.form.ej2_instances[0].addRules('YarnQualityID', { required: true });
        args.form.ej2_instances[0].addRules('YarnTypeID', { required: true });
        args.form.ej2_instances[0].addRules('HSCodeID', { required: true, });

      }
      if (args.requestType === 'save' && args?.action === 'add') {
        const data = {
          UserId: userId,
          ...args.data
        };
        console.log('args: ', args.data)
        fullYarnCountService.create(data).then((response) => {
          console.log(`${args.data.YarnCount}/${args.data.YarnThread}${args.data.YarnQuality} ${args.data.YarnType}`)
          console.log('response: ', response);

        let AddData = {
          FullYarnCount: `${args.data.YarnCount}/${args.data.YarnThread}${args.data.YarnQuality} ${args.data.YarnType}`
          
        }
        AuditTableInput.auditAdd(`FullYarnCount`,`FullYarnCount`,`FullYarnCountID`,AddData)
          setFullYarnCounts(response.data.recordset);
          // fullYarnCountGrid.refresh()
          // const type = getRoute()[1];
          // getFullYarnCounts(type);

        });
      }
      if (args.requestType === 'save' && args?.action === 'edit') {
        const data = {
          UserId: userId,
          ...args.data
        };
        console.log('edit args: ', args.data)
        fullYarnCountService.edit(data, args?.data?.FullYarnCountID).then((response) => {
          console.log('response: ', response);
          console.log(`${args.data.YarnCount}/${args.data.YarnThread}${args.data.YarnQuality} ${args.data.YarnType}`)
          let EditData = {
            FullYarnCount: `${args.data.YarnCount}/${args.data.YarnThread}${args.data.YarnQuality} ${args.data.YarnType}`,
            
          }
          let totalColumns = Object.keys(EditData);
          console.log(totalColumns)

          AuditTableInput.auditEdit(totalColumns,selectedRows,EditData,`FullYarnCount`,args.data.FullYarnCountID)
          setFullYarnCounts(response.data.recordset);
          // fullYarnCountGrid.refresh()
          // const type = getRoute()[1];
          // getFullYarnCounts(type);

        });
      }

    }

  };

  const thousandSeperator = (field: string, data: object, column: Column) => {
    const value = data[column.field];
    console.log(value);
    if (value) {
        let parts = value.toString().split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return parts.join('.');
    }
  }
  // const commandClick = (args: CommandClickEventArgs) => {
  //   setShowDialog(false);
  //   console.log('command click args: ', args);
  //   setSelectedRow(args.rowData);
  //   setShowDialog(true);
  // };

  // const commands: CommandModel[] = [
  //   {
  //     buttonOption: {
  //       content: 'Delivery Schedule',
  //       cssClass: 'e-flat',
  //     },
  //   },
  // ];

  // const dialogClose = () => {
  //   this.buttonInstance.style.display = 'inline-block';
  //   setShowDialog(false);
  // };

  // const openDialog = () => {
  //   setShowDialog(true);
  // };

  const DELETE_MESSAGE = "DELETED SUCCESSFULLY";
  const CONFLICT_MESSAGE = "CONFLICT IN DATABASE";
  const deleteRow = () => {
    FullYarnCountService.delete(deletingID)
      .then((response) => {
        console.log(response);
        setWarningMessage(DELETE_MESSAGE);
        warningDialog.current.show();
      })
      .catch((e) => {
        setWarningMessage(CONFLICT_MESSAGE);
        warningDialog.current.show();
      });
  };

  const deleteButtons = [
    {
      buttonModel: {
        content: "OK",
        cssClass: "e-flat",
        isPrimary: true,
      },
      click: (e) => {
        deleteDialog.current.hide();
        console.log(e);
        deleteRow();
      },
    },
    {
      buttonModel: {
        content: "Cancel",
        cssClass: "e-flat",
      },
      click: () => {
        deleteDialog.current.hide();
      },
    },
  ];

  const warningButtons = [
    {
      buttonModel: {
        content: "OK",
        cssClass: "e-flat",
        isPrimary: true,
      },
      click: () => {
        warningDialog.current.hide();
        // setTimeout(() => {
        //   if (!(warningMessage.includes('access denied'))) {
        //     // record was succesfully deleted
        //     const type = getRoute()[1];
        //     getYarnContracts(type);
        //     // console.log("record was succesfully deleted");
        //   }
        // }, 500);
      },
    },
  ];

  function deleteDialogClose() {
    setDeleteDialogVisibility(false);
  }

  function warningDialogClose() {
    setDialogWarningVisibility(false);
    if (warningMessage.includes(DELETE_MESSAGE)) {
      getFullYarnCounts();
    }
  }

  const DeleteDialogComponent = () => (
    <div>
      <DialogComponent
        ref={deleteDialog}
        width={500}
        visible={deleteDialogVisibility}
        close={deleteDialogClose}
        content={() => <div>Are you sure you want to delete?</div>}
        isModal={true}
        header="Confirmation"
        buttons={deleteButtons}
      // footerTemplate={footerTemplate}
      />
      <DialogComponent
        ref={warningDialog}
        width={400}
        visible={dialogWarningVisibility}
        close={warningDialogClose}
        content={() => <div>{warningMessage}</div>}
        isModal={true}
        header="Warning"
        buttons={warningButtons}
      // footerTemplate={footerTemplate}
      />
    </div>
  );

  const FullYarnCountGridComponent = useMemo(() => ({ restrictPageSize = 12 }) => (
    <GridComponent
      ref={(grid) => (fullYarnCountGrid = grid)}
      id='fullYarnCountGrid'
      dataSource={fullYarnCounts}
      editSettings={editSettings}
      toolbar={toolbarOptions}
      pageSettings={{ pageCount: 4, pageSizes: true, pageSize: restrictPageSize }}
      filterSettings={filterOptions}
      groupSettings={groupOptions}
      actionComplete={actionComplete}
      allowTextWrap='true'
      // commandClick={commandClick}

      allowPaging={true}
      allowSorting={true}
      allowPdfExport={true}
      allowExcelExport={true}
      toolbarClick={toolbarClick}
      allowFiltering={true}
      allowGrouping={true}
      showColumnChooser={true}
      allowReordering={true}
      allowResizing={true}
      sortSettings={sortingOptions}
    // dataBound={databound}
    rowSelected={
      (args)=>{
        console.log(args.data)
        selectedRows = args.data
        
                  setTimeout(() => {
          console.log('ss')
        }, 200);
      }
    }
    >
      <ColumnsDirective>
        {/* <ColumnDirective
                headerText='Commands'
                width='170'
                commands={commands}
                textAlign='Left'
              /> */}

<ColumnDirective
          headerText='ID'
          field='FullYarnCountID'
          width='120'
          headerTextAlign='Center'
          textAlign='Right'
        />
        <ColumnDirective
          headerText='Full Yarn Count'
          field='FullYarnCount'
          width='200'
          textAlign='Left'
          headerTextAlign='Center'
        />
        {/* <ColumnDirective
                headerText='Order Date'
                field='OrderDate'
                width='200'
                
                type='date'
                format='dd/MM/yy'
              /> */}
        <ColumnDirective
          headerText='Yarn Count'
          field='YarnCount'
          width='100'
          textAlign='Right'
          headerTextAlign='Center'
          valueAccessor={thousandSeperator}

        />
        <ColumnDirective
          headerText='Yarn Thread'
          field='YarnThread'
          headerTextAlign='Center'
          textAlign='Right'
         width='100'
         valueAccessor={thousandSeperator}

        />
        <ColumnDirective
          headerText='Yarn Quality'
          field='YarnQuality'
          width='150'
          textAlign='Left'
          headerTextAlign='Center'
        />
        <ColumnDirective
          headerText='Yarn Type'
          field='YarnType'
          width='150'
          textAlign='Left'
          headerTextAlign='Center'

        />
        {/* <ColumnDirective
                headerText='Bags Ordered'
                field='OrderBags'
                width='150'
              />
              <ColumnDirective
                headerText='Bags Weight'
                field='WeightPerBag'
                width='150'
              />
              <ColumnDirective
                headerText='Procurement Type'
                field='ProcurementType'
                width='150'
              />
              <ColumnDirective
                headerText='Start Date'
                field='ContractStartDate'
                width='150'
                type='date'
              />
              <ColumnDirective
                headerText='End Date'
                field='ContractEndDate'
                width='150'
                type='date'
              />
              <ColumnDirective
                headerText='Currency'
                field='CurrencyName'
                width='140'
              />
              <ColumnDirective
                headerText='Foreign Currency Rate'
                field='ForeignCurrencyRate'
                width='200'
              />
              <ColumnDirective
                headerText='Foreign Currency Amount'
                field='ForeignCurrencyAmount'
                width='200'
              />
              <ColumnDirective
                headerText='Contract Exchange Rate'
                field='ContractExchangeRate'
                width='200'
              />
              <ColumnDirective
                headerText='Bags Received'
                field='ReceivedBags'
                width='140'
              />
              <ColumnDirective
                headerText='Bags Returned'
                field='ReturnedBags'
                width='140'
              />
              <ColumnDirective
                headerText='Tax %'
                field='TaxPercent'
                width='100'
              />
              <ColumnDirective
                headerText='Tax Type'
                field='TaxType'
                width='150'
              /> */}
      </ColumnsDirective>

      {/* <AggregatesDirective>
              <AggregateDirective>
                <AggregateColumnsDirective>
                  <AggregateColumnDirective
                    field='OrderBags'
                    type='Sum'
                    footerTemplate={footerSum}
                  />
                </AggregateColumnsDirective>
              </AggregateDirective>
              <AggregateDirective>
                <AggregateColumnsDirective>
                  <AggregateColumnDirective
                    field='OrderBags'
                    type='Sum'
                    groupFooterTemplate={footerSum}
                  />
                </AggregateColumnsDirective>
              </AggregateDirective>
            </AggregatesDirective> */}

      <Inject
        services={[
          Edit,
          Toolbar,
          Page,
          Sort,
          PdfExport,
          ExcelExport,
          Filter,
          Group,
          Aggregate,
          Freeze,
          ColumnChooser,
          Reorder,
          Resize,
          // CommandColumn,
        ]}
      />
    </GridComponent>
  ), [fullYarnCounts]);

  const userId = securityService.getLoggedInUserId();

  return (
    (props.isDialog) ? (
      <div>
        <DeleteDialogComponent />
        <FullYarnCountGridComponent restrictPageSize={5} />
      </div>
    )
      :
      (
        <div className="content-wrapper">
          <div>
          {showDialogs ?
          <HardDelete
            {...deletingProps} 
            showResult={(e)=>{
                                console.log(e)

                                setShowDialogs(false)
                                if(e == false){
                                  setShowDialogs(false)
                                  // setProcessingDetails(
                                  //   processingDetails.filter(
                                  //     (item) => item?.FabricProcessingContractDetailID !== deletingID
                                  //   )
                                  // );

                                  //  fabricProcessingContractGrid.dataSource[args?.rowIndex] =   args?.data;
        // console.log("save: ", data);
        // FabricProcessingContractService.create(data);
        setTimeout(() => {
          
          // yarnCountGrid.refresh()
          getFullYarnCounts();

        }, 200);
      // getProductCutSize(props.path.substring(1));

                                  // const type = getRoute()[1];
                                  // getProcessDesc(type);
                                }
              }} 
                ></HardDelete>
                  :null}

            <div>
              <h3>Full Yarn Count - List</h3>
              <DeleteDialogComponent />
              <div>
                {/* <ButtonComponent onClick={addYarnContract}>Add </ButtonComponent> */}
                {/* <button
                  className='m-3 btn btn-sm btn-primary'
                  onClick={this.addYarnContract}
                >
                  Add
                </button> */}
              </div>
              {/* <div>
                <ReactDataGrid columns={columns} rows={rows} editor={true} />
              </div> */}

              {/* <div className='e-statustext'>
                    Select column name to toggle visibility
                  </div> */}
              {/* <ToolbarComponent
                    id='toolbar'
                    ref={(toolbar) => (this.ToolbarInstance = toolbar)}
                    onClick={toolBarClick(this)}
                  >
                    <ItemsDirective>
                      <ItemDirective text='Order ID' />
                      <ItemDirective text='Customer Name' />
                      <ItemDirective text='Freight' />
                      <ItemDirective text='Order Date' />
                      <ItemDirective text='Shipped Date' />
                      <ItemDirective text='Ship Country' />
                    </ItemsDirective>
                  </ToolbarComponent> */}
              {/* <div className='App' id='dialog-target'>
              <DialogComponent
                width='600px'
                target='#dialog-target'
                visible={showDialog}
                close={dialogClose}
                content={contentTemplate}
                isModal={true}
                showCloseIcon={true}
                header={header}
                
              />
            </div> */}

              <FullYarnCountGridComponent />
            </div>
          </div>
        </div>
      )
  );
}
